export const saveToFs = async (directLink: string, title: string) => {
  const response = await fetch(directLink);
  const blob = await response.blob();
  const typedBlob = new Blob([blob], { type: 'audio/mpeg' });

  const fileUrl = window.URL.createObjectURL(typedBlob);
  const anchorElement = document.createElement('a');

  let finalTitle = title.replace(/[^a-zA-Z0-9 \-().]/g, '') || 'file_name';

  if (!finalTitle.endsWith('.mp3')) {
    finalTitle+= '.mp3';
  }

  console.log(' saveToFs: ', finalTitle);

  anchorElement.href = fileUrl;
  anchorElement.download = finalTitle;
  anchorElement.style.display = 'none';

  document.body.appendChild(anchorElement);

  anchorElement.click();
  anchorElement.remove();

  window.URL.revokeObjectURL(fileUrl);
  return true;
}
